import { randomNumber } from '../../../utilities'
import { IPcr } from '../../pcr/store/pcr.types'
import { IPatientVitals } from '../../vitals/store/vitals.types'
import { IItem } from '../store/timeline.types'

export function modifyParentVitalsObject(selectedItem: IItem, pcrDoc: IPcr): IPcr {
  if (!pcrDoc.patient.timelineItems || !pcrDoc.patient.patientVitals) return pcrDoc

  const timelineVitalIndex = pcrDoc.patient.timelineItems.findIndex(
    (timelineItem) => timelineItem.clientEventId === selectedItem.key
  )
  const newKey = randomNumber().toString()

  const timelineItem = pcrDoc.patient.timelineItems[timelineVitalIndex]
  const updatedParentVital: IItem = {
    ...timelineItem,
    key: newKey,
    isEkgImport: -1,
    clientEventId: undefined,
    vsAction: undefined,
  }

  pcrDoc.patient.timelineItems[timelineVitalIndex] = updatedParentVital

  const patientVitalIndex = pcrDoc.patient.patientVitals.findIndex((vital) => vital.key === timelineItem.key)
  const patientVital = pcrDoc.patient.patientVitals[patientVitalIndex]
  const updatedPatientVital: IPatientVitals = {
    ...patientVital,
    key: newKey,
    isEkgImport: -1,
    clientEventId: null,
    vsAction: null,
  }

  pcrDoc.patient.patientVitals[patientVitalIndex] = updatedPatientVital

  return pcrDoc
}
